import React, { useEffect, useState } from 'react';

import BootstrapSelect from '../bootstrap-select/BootstrapSelect';
//import { Map as ImmutableMap } from 'immutable';
import data from '../../static/amtLanguages.json';

const AmtLanguageSelection = ({ languageOptions }) => {
  const displayLocale = (localeCode, localeText) => {
    return localeText + ' (' + localeCode + ')';
  };

  const languages = [];
  Object.keys(languageOptions).forEach(language => {
    const key = languageOptions[language];
    languages.push(
      <option value={key} key={key}>
        {displayLocale(key, language)}
      </option>
    );
  });
  return languages;
};

const AmtLanguageSelect = ({ value, onChange, className = '', placeholderText = '' }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('');

  useEffect(() => {
    setSelectedLanguage(value);
  }, [value]);

  const processGenericLanguage = locale => {
    setSelectedLanguage(locale);
    onChange(locale);
  };

  return (
    <div className={className}>
      <div className="mt-1 mb-1">
        <BootstrapSelect
          el-width="100%"
          data-size="5"
          data-live-search="true"
          value={selectedLanguage}
          onChange={e => processGenericLanguage(e.target.value)}
        >
          <option value="" key="">
            {placeholderText}
          </option>
          <AmtLanguageSelection languageOptions={data} />
        </BootstrapSelect>
      </div>
    </div>
  );
};

export default AmtLanguageSelect;
